__turbopack_context__.v({
  "bruketIWiaredApp": "MainFooter-module-scss-module__icWbdG__bruketIWiaredApp",
  "brutaleApp": "MainFooter-module-scss-module__icWbdG__brutaleApp",
  "butchersMarketApp": "MainFooter-module-scss-module__icWbdG__butchersMarketApp",
  "cartDrawerOpen": "MainFooter-module-scss-module__icWbdG__cartDrawerOpen",
  "cornerApp": "MainFooter-module-scss-module__icWbdG__cornerApp",
  "footer": "MainFooter-module-scss-module__icWbdG__footer",
  "footerBrand": "MainFooter-module-scss-module__icWbdG__footerBrand",
  "gronaLundApp": "MainFooter-module-scss-module__icWbdG__gronaLundApp",
  "heatApp": "MainFooter-module-scss-module__icWbdG__heatApp",
  "kafeMagasinetApp": "MainFooter-module-scss-module__icWbdG__kafeMagasinetApp",
  "keemchiApp": "MainFooter-module-scss-module__icWbdG__keemchiApp",
  "klappenBagerietApp": "MainFooter-module-scss-module__icWbdG__klappenBagerietApp",
  "klappenToppstuganApp": "MainFooter-module-scss-module__icWbdG__klappenToppstuganApp",
  "leftLinksContainer": "MainFooter-module-scss-module__icWbdG__leftLinksContainer",
  "linksContainer": "MainFooter-module-scss-module__icWbdG__linksContainer",
  "linksRow": "MainFooter-module-scss-module__icWbdG__linksRow",
  "lunchboxApp": "MainFooter-module-scss-module__icWbdG__lunchboxApp",
  "lundsKommunApp": "MainFooter-module-scss-module__icWbdG__lundsKommunApp",
  "morenoPizzaApp": "MainFooter-module-scss-module__icWbdG__morenoPizzaApp",
  "nordrestAxisApp": "MainFooter-module-scss-module__icWbdG__nordrestAxisApp",
  "olandschokladApp": "MainFooter-module-scss-module__icWbdG__olandschokladApp",
  "orderingTagLine": "MainFooter-module-scss-module__icWbdG__orderingTagLine",
  "primaryLeftContainer": "MainFooter-module-scss-module__icWbdG__primaryLeftContainer",
  "primaryRow": "MainFooter-module-scss-module__icWbdG__primaryRow",
  "rightLinksContainer": "MainFooter-module-scss-module__icWbdG__rightLinksContainer",
  "secondaryRow": "MainFooter-module-scss-module__icWbdG__secondaryRow",
  "strandgatanApp": "MainFooter-module-scss-module__icWbdG__strandgatanApp",
  "tacosAndTequilaApp": "MainFooter-module-scss-module__icWbdG__tacosAndTequilaApp",
  "versionText": "MainFooter-module-scss-module__icWbdG__versionText",
  "whiteLabeled": "MainFooter-module-scss-module__icWbdG__whiteLabeled",
});
